import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { BonusInfoDesc } from 'src/components/Bonus';
import Intl from "./common/Intl";
import { Link } from 'react-router-dom';

function WelcomeBonusYolo(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <InformationWrapper>
            <BonusInfoContainer>
                <BonusInfoHeadH1>
                    <Intl langKey="PROMOTIONSWELCOMEYolo@HeadingH1"/>
                    <em className='italicText'><Intl langKey="PROMOTIONSWELCOMEYolo@HeadingItalic"/></em>
                </BonusInfoHeadH1>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@HeadingDesc" /></BonusInfoDesc>

                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOMEYolo@WhatIsWB" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@WhatIsWBDesc" /></BonusInfoDesc>
                <Link to='/signup' className='ctaLink'><Intl langKey="PROMOTIONSWELCOMEYolo@SignUp" /></Link>
            </BonusInfoContainer>

            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOMEYolo@HowDoYouClaimThisBonus" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@HowDoYouClaimThisBonusDesc" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@Example" /></BonusInfoDesc>
                <ol type="a" className='customOl'>
                    <li className='bold'><Intl langKey="PROMOTIONSWELCOMEYolo@ExampleText1" /></li>
                    <li className='bold'><Intl langKey="PROMOTIONSWELCOMEYolo@ExampleText2" /></li>
                    <li className='bold'><Intl langKey="PROMOTIONSWELCOMEYolo@ExampleText3" /></li>
                </ol>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@HowDoYouClaimThisBonusDescLast" /></BonusInfoDesc>
            </BonusInfoContainer>

            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirement" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirementDesc1" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirementDesc2" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirementDesc3" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirementDesc4" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirementDesc5" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@RORequirementDesc6" /></BonusInfoDesc>
            </BonusInfoContainer>

            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioA" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioADesc1" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioADesc2" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioADesc3" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioADesc4" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioB" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioBDesc1" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioBDesc2" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioBDesc3" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioBDesc4" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioC" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioCDesc1" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioCDesc2" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioCDesc3" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioCDesc4" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioCDesc5" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOMEYolo@ScenarioCDesc6" /></BonusInfoDesc>
            </BonusInfoContainer>
            <Link to='/signup' className='ctaLink'><Intl langKey="PROMOTIONSWELCOMEYolo@JoinAndDepo" /></Link>
                        
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOME@TERMS" /></BonusInfoHeadH3>
                <BonusInfoDesc>
                    <ol>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS1" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS2" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS3" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS4" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS5" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS6" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS7" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS8" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS9" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS10" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS11" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS12" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS13" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS14" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS15" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOMEYolo@TERMS16" /></li>
                    </ol>
                </BonusInfoDesc>
            </BonusInfoContainer>
        </InformationWrapper>
    )
}

export default withTheme(withAppContext(WelcomeBonusYolo));

// Styled Component.
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem;
    border:1px solid white;
    border-radius: 1px;
    background: rgb(0 0 0 / 41%);
    margin: 0em 1.2em;
    backdrop-filter: brightness(0.5);

    & ul li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        -webkit-letter-spacing: 0.01em;
        -moz-letter-spacing: 0.01em;
        -ms-letter-spacing: 0.01em;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

    & span {
        display: flex;
        flex-direction: column; 
        right: 0px;
        width: auto;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        text-transform: capitalize;
        color: #FFFFFF;
        align-items: flex-end;

        @media only screen and (min-width: 1700px){
            font-size: 16px;
        }
    }

    .italicText {
        font-size: 14px;
        margin-left: 10px;
        border-bottom: 1px solid;
    }

    .ctaLink {
        color: #f4a322;
        font-size: 15px;
        border-bottom: 1px solid;
        margin: 1rem 0;
        display: inline-block;

        :hover {
            color: #6778e3;
        }
    }

    .customOl {
        display: inline-block;
        padding: 1rem;
        padding-left: 2rem;
        background-color: #adadad4d;
        border-radius: 5px;
        border-left: 2px solid #ffffff;
    }
`;

const BonusInfoContainer = styled.div`
    width: 100%;
    margin: auto;
    padding-bottom: 10px;

   & h6 {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #C2D2FF;
        margin: 25px 0px 20px 0px;
    }

   & h5 {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

   & ul,li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
    }

    .bold {
        font-weight: bold;
        font-size: 14px;
    }
`;

const BonusInfoHeadH3 = styled.h3`
    font-style: normal;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH1 = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;